import be from './be';
import de from './de';
import shared from './shared';

export default { be: { ...shared, ...be }, de: { ...shared, ...de } };
